// extracted by mini-css-extract-plugin
export var bubble = "_1l-0";
export var container = "_1l-f";
export var contrastBorder = "_1l-g";
export var greyOut = "_1l-2";
export var initialsColor0 = "_1l-3";
export var initialsColor1 = "_1l-4";
export var initialsColor10 = "_1l-d";
export var initialsColor11 = "_1l-e";
export var initialsColor2 = "_1l-5";
export var initialsColor3 = "_1l-6";
export var initialsColor4 = "_1l-7";
export var initialsColor5 = "_1l-8";
export var initialsColor6 = "_1l-9";
export var initialsColor7 = "_1l-a";
export var initialsColor8 = "_1l-b";
export var initialsColor9 = "_1l-c";
export var initialsWrapper = "_1l-1";
export var large = "_1l-l";
export var medium = "_1l-k";
export var mediumSmall = "_1l-j";
export var mediumSmallMedium = "_1l-o";
export var micro = "_1l-h";
export var small = "_1l-i";
export var tiny = "_1l-n";
export var xTiny = "_1l-m";